/*
,------.                                    ,--.          ,--.      ,--------.    ,------.            ,--.           
|  .-.  \,--. ,--.,--,--,  ,--,--.,--,--,--.`--' ,---.    |  | ,---.'--.  .--'    |  .-.  \  ,--,--.,-'  '-. ,--,--. 
|  |  \  :\  '  / |      \' ,-.  ||        |,--.| .--'    |  || .-. |  |  |       |  |  \  :' ,-.  |'-.  .-'' ,-.  | 
|  '--'  / \   '  |  ||  |\ '-'  ||  |  |  ||  |\ `--.    |  |' '-' '  |  |       |  '--'  /\ '-'  |  |  |  \ '-'  | 
`-------'.-'  /   `--''--' `--`--'`--`--`--'`--' `---'    `--' `---'   `--'       `-------'  `--`--'  `--'   `--`--' 
         `---'                                                                                                      
*/
import { VisionApplication } from './application';
import { VisionFleetTab } from './tab/fleet_tab/fleet';
import { VisionSpotRockingTab } from './tab/spot_rocking_tab/spot_rocking';
import { VisionRockingTab } from './tab/rocking_tab/rocking';
import { VisionAVLTab2 } from './tab/avl_tab/avl_tab';
import { VisionRockPitsTab } from './tab/rockpits_tab/rockpits_tab';
import { PreventativeMaintenanceTab } from './tab/pm/pm';
import { VisionGradingTab } from './tab/grading_tab/grading';
import { VisionMowingTab } from './tab/mower_tab/mower';
import { VisionPlowingTab } from './tab/plowing_tab/plowing';
import { VisionSpreadingTab } from './tab/spreading_tab/spreading';
import { VisionCameraTab } from './tab/camera_tab/camera';
import { VisionUserWindow } from './window/user.window';
import { VisionAccountWindow } from './window/account';
import { VisionSweapingTab } from './tab/sweaper_tab/sweaper';

export class VisionLayout {
    app: VisionApplication;
    layout!: dhtmlXLayoutObject;
    tabbar!: dhtmlXTabBar;

    fleetTab: VisionFleetTab;
    gradingTab: VisionGradingTab;
    mowingTab: VisionMowingTab;
    plowingTab: VisionPlowingTab;
    spreadingTab: VisionSpreadingTab;
    sweapingTab: VisionSweapingTab;

    spotRockingTab: VisionSpotRockingTab;
    rockingTab: VisionRockingTab;
    avl2Tab: VisionAVLTab2;
    pmTab: PreventativeMaintenanceTab;
    rockpitsTab: VisionRockPitsTab;
    cameraTab: VisionCameraTab;

    constructor(app: VisionApplication) {
        this.app = app;

        const config: IdhtmlXLayoutConfig = {
            parent: document.body,
            pattern: '1C',
        };

        this.layout = new dhtmlXLayoutObject(config);
        this.tabbar = this.layout.cells('a').attachTabbar();
        this.tabbar.addTab('ACCOUNT', "<img src='icons/logout.png' style='vertical-align:middle; height=24'/>", 48, 1, true, false);
        this.tabbar.addTab('AVL2', "<img src='icons/truck-pickup.png' style='vertical-align:middle; height=24'/>&nbsp;&nbsp;AVL", 130, 1, true, false);
        this.tabbar.addTab('CAMERA', "<img src='icons/camera.png' style='vertical-align:middle; height=24'/>&nbsp;&nbsp;CAMERA", 130, 2, true, false);
        this.tabbar.addTab('FLEET', "<img src='icons/fleet-tab.png' style='vertical-align:middle; height=20' />&nbsp;&nbsp;FLEET", 140, 3, true, false);
        this.tabbar.addTab('PM', "<img src='icons/wrench.png' style='vertical-align:middle;' />&nbsp;&nbsp;PM", 100, 4, true, false);
        this.tabbar.addTab('SPOT ROCKING', "<img src='icons/target.png' style='vertical-align:middle;' />&nbsp;&nbsp;SPOT ROCKING", 200, 5, true, false);
        this.tabbar.addTab('ROCK PITS', "<img src='icons/rock.png' style='vertical-align:middle; height='30' />&nbsp;&nbsp;ROCK PITS", 130, 6, true, false);
        this.tabbar.addTab('ROCKING', "<img src='icons/boxup.png' style='vertical-align:middle;' />&nbsp;&nbsp;ROCKING", 130, 7, true, false);
        //this.tabbar.addTab("SWEEPING", "SWEEPING", 100, 5, true, false);
        this.tabbar.addTab('GRADING', "<img src='icons/grader-tab.png' style='vertical-align:middle;' height='32' />&nbsp;&nbsp;GRADING", 130, 8, true, false);
        this.tabbar.addTab('MOWING', "<img src='icons/tractor.png' style='vertical-align:middle;' />&nbsp;&nbspMOWING", 130, 9, true, false);

        //this.tabbar.addTab("BLADING", "BLADING", 100, 7, true, false);
        this.tabbar.addTab('PLOWING', "<img src='icons/plow.png' style='vertical-align:middle;' height='20' />&nbsp;&nbsp;PLOWING", 150, 10, true, false);
        this.tabbar.addTab('SPREADING', "<img src='icons/spread.png' style='vertical-align:middle; height='30' />&nbsp;&nbsp;SPREADING", 130, 11, true, false);
        this.tabbar.addTab('SWEAPING', "<img src='icons/broom.png' style='vertical-align:middle;' />&nbsp;&nbsp;SWEAPING", 130, 12, true, false);

        this.tabbar.cells('AVL2').attachObject(document.getElementById('full'));
        this.fleetTab = new VisionFleetTab(this);
        this.spotRockingTab = new VisionSpotRockingTab(this);
        this.rockingTab = new VisionRockingTab(this);
        this.pmTab = new PreventativeMaintenanceTab(this);

        const lastTab = localStorage.getItem('lastTab');

        this.avl2Tab = new VisionAVLTab2(this);
        this.rockpitsTab = new VisionRockPitsTab(this);
        this.gradingTab = new VisionGradingTab(this);
        this.plowingTab = new VisionPlowingTab(this);
        this.spreadingTab = new VisionSpreadingTab();
        this.mowingTab = new VisionMowingTab(this);
        this.cameraTab = new VisionCameraTab(this);
        this.sweapingTab = new VisionSweapingTab(this);

        //alert("Loading");
        this.setupEvents();
        this.tabbar.tabs('AVL2').setActive();

        if (lastTab != null) {
            this.tabbar.tabs(lastTab).setActive();
        }
        this.hideTabs();
    }

    private hideTabs() {
        const usersettings = JSON.parse(VisionApplication.getInstance().userService.userSettings.settings);
        if (usersettings != null) {
            this.tabbar.tabs('AVL2').hide();
            this.tabbar.tabs('CAMERA').hide();
            this.tabbar.tabs('FLEET').hide();
            this.tabbar.tabs('PM').hide();
            this.tabbar.tabs('SPOT ROCKING').hide();
            this.tabbar.tabs('ROCKING').hide();
            this.tabbar.tabs('ROCK PITS').hide();
            this.tabbar.tabs('GRADING').hide();
            this.tabbar.tabs('MOWING').hide();
            this.tabbar.tabs('PLOWING').hide();
            this.tabbar.tabs('SPREADING').hide();
            this.tabbar.tabs('SWEAPING').hide();
        }

        usersettings?.tabs.forEach((tab: string) => {
            switch (tab) {
                case 'avl':
                    this.tabbar.tabs('AVL2').show(true);
                    break;
                case 'fleet':
                    this.tabbar.tabs('FLEET').show(false);
                    break;
                case 'pm':
                    this.tabbar.tabs('PM').show(false);
                    break;
                case 'spot_rocking':
                    this.tabbar.tabs('SPOT ROCKING').show(false);
                    break;
                case 'rocking':
                    this.tabbar.tabs('ROCKING').show(false);
                    break;
                case 'rock_pits':
                    this.tabbar.tabs('ROCK PITS').show(false);
                    break;
                case 'grading':
                    this.tabbar.tabs('GRADING').show(false);
                    break;
                case 'mowing':
                    this.tabbar.tabs('MOWING').show(false);
                    break;
                case 'plowing':
                    this.tabbar.tabs('PLOWING').show(false);
                    break;
                case 'spreading':
                    this.tabbar.tabs('SPREADING').show(false);
                    break;
                case 'camera':
                    this.tabbar.tabs('CAMERA').show(false);
                    break;
                case 'sweaping':
                    this.tabbar.tabs('SWEAPING').show(false);
                    break;
            }
        });
    }

    private setupEvents() {
        this.tabbar.attachEvent('onSelect', (id) => {
            if (id != 'ACCOUNT') {
                localStorage.setItem('lastTab', id);
            }

            switch (id) {
                case 'ACCOUNT': {
                    window.location.href = 'https://dynamiciotdata.com/login.html';
                    //const window = new VisionAccountWindow(this.app.windowManager);
                    //window?.show();
                    return true;
                }
                case 'CAMERA':
                    this.cameraTab.init();
                    break;
                case 'FLEET':
                    this.fleetTab.init();
                    break;
                case 'PM':
                    this.pmTab.onSelect();
                    break;
                case 'ROCKING':
                    this.rockingTab.onSelect();
                    break;
                case 'GRADING':
                    this.gradingTab.onSelect();
                    break;
                case 'MOWING':
                    this.mowingTab.onSelect();
                    break;
                case 'PLOWING':
                    this.plowingTab.onSelect();
                    break;
                case 'SPREADING':
                    this.spreadingTab.onSelect();
                    break;
                case 'SWEAPING':
                    this.sweapingTab.onSelect();
                    break;
            }

            return true;
        });

        this.layout.attachEvent('onDblClick', (name) => {
            if (name == 'a') {
                if (this.layout.cells('a').isCollapsed()) {
                    this.layout.cells('a').expand();
                    this.layout.cells('a').setHeight(200);
                } else {
                    this.layout.cells('a').collapse();
                }
            }
        });

        this.layout.attachEvent('onPanelResizeFinish', () => {
            //console.log('Panel Resize');
        });

        this.layout.attachEvent('onResize', () => {
            //console.log('Event - OnResize');
        });
        this.layout.attachEvent('onCollapse', () => {
            //console.log('Event - Collapse');
        });
        this.layout.attachEvent('onExpand', () => {
            //console.log('Event - Expand');
        });
    }

    public init() {
        this.plowingTab.init();
        this.spreadingTab.init();
    }
}
